// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"364":"94e9aabe","521":"94e9aabe"}[chunkId] + ".chunk.css";
};